import React from 'react';
import DeployImage from "/Images/newasset1.svg"; // Gambar deployment
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Material UI Icon
import { useMediaQuery } from '@mui/material';
import { Link } from "react-router-dom";

const DeploymentSection = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  const styles = {
    container: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row', // Column layout for mobile
      justifyContent: isMobile ? 'center' : 'space-between',
      alignItems: 'center',
      backgroundColor: '#E0DCD9',
      padding: isMobile ? '50px 30px' : '100px',
      borderRadius: '10px',
      textAlign: isMobile ? 'center' : 'left',
    },
    imageContainer: {
      marginBottom: isMobile ? '20px' : '0',
      width: isMobile ? '100%' : '45%',
      display: 'flex',
      justifyContent: 'center',
    },
    image: {
      width: isMobile ? "80%" : "574px", // Adjust image width for mobile
      maxWidth: isMobile? "400px" :"574px",
      borderRadius: "10px",
    },
    textContainer: {
      width: isMobile ? '100%' : '45%',
      paddingLeft: isMobile ? '0' : '20px',
    },
    heading: {
      color: '#2D669B',
      fontSize: isMobile ? '20px' : '30px', // Smaller font size on mobile
      fontWeight: '600',
      marginBottom: '20px',
    },
    paragraph: {
      color: '#6D6D6D',
      fontSize: isMobile ? '0.875rem' : '1rem', // Smaller font size on mobile
      lineHeight: '1.6',
      marginBottom: '20px',
      textAlign: 'justify',
      minWidth: isMobile ? 'auto' : '540px',
    },
    exploreMore: {
      color: '#B0990D',
      fontSize: isMobile ? '0.875rem' : '1rem', // Smaller font size on mobile
      textDecoration: 'underline',
      display: 'flex',
      alignItems: 'center',
      justifyContent: isMobile ? 'flex-start' : 'flex-start',
      marginTop: '20px',
      cursor: 'pointer',
    },
    arrow: {
      marginLeft: '10px',
      backgroundColor: '#2D669B',
      borderRadius: '50%',
      padding: '5px',
      color: '#F4E37B',
    },
  };

  return (
    <div style={styles.container}>
      {/* Image Container */}
      <div style={styles.imageContainer}>
        <img src={DeployImage} alt="Deployment" style={styles.image} />
      </div>

      {/* Text Container */}
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Trust in Every Transaction, <br />
          Our Commitment to You
        </h2>
        <p style={styles.paragraph}>
          Tennet prioritizes the security of your digital assets above all else. 
          Our state-of-the-art technology and stringent protocols ensure that your holdings 
          are protected with the highest level of integrity. We understand the importance of trust 
          in the digital landscape, which is why we implement robust security measures and rigorous 
          protocols that are constantly updated to stay ahead of emerging risks. With Tennet, you can 
          navigate the complexities of the digital economy with confidence, knowing your assets are in expert hands.
        </p>
        <Link to="/usecase" style={{ textDecoration: 'none' }}>
        <div style={styles.exploreMore}>
          Explore More
          <ArrowForwardIcon style={styles.arrow} />
        </div>
        </Link>
      </div>
    </div>
  );
};

export default DeploymentSection;
